import { BREAKPOINTS, MEDIA_QUERIES, DEVICES } from './Responsive.constants';
import type { Device } from './Responsive.constants';
type UserAgent = string;
const IS_CLIENT = typeof window !== 'undefined';
export function getDOMAspect() {
  if (IS_CLIENT) {
    const el = window.document.documentElement;
    const { fontSize } = window.getComputedStyle(el);
    return {
      viewportWidthPX: el.clientWidth,
      viewportHeightPX: el.clientHeight,
      htmlFontSize: parseInt(fontSize || '0', 10),
    };
  }

  return {
    viewportWidthPX: 0,
    viewportHeightPX: 0,
    htmlFontSize: 0,
  };
}
export function getDeviceByUA(userAgent: UserAgent = '') {
  if (/(tablet|iPad)/i.test(userAgent)) {
    return DEVICES.TABLET;
  }

  if (!userAgent || /(mobile|iPhone|Android)/i.test(userAgent)) {
    return DEVICES.MOBILE;
  }

  return DEVICES.DESKTOP;
}
export function getCurrentBreakpoint(device: Device = DEVICES.MOBILE): Breakpoint {
  if (IS_CLIENT) {
    return MEDIA_QUERIES.reduce((previous, { mediaquery, breakpoint }) => {
      if (window.matchMedia(mediaquery).matches) {
        return breakpoint;
      }

      return previous;
    }, BREAKPOINTS.XXS);
  }

  if (device === DEVICES.DESKTOP) {
    return BREAKPOINTS.XL;
  }

  return BREAKPOINTS.XXS;
}
export function isLandscape() {
  return IS_CLIENT ? window.matchMedia('all and (orientation:landscape)').matches : false;
}
export function isRTL() {
  return IS_CLIENT ? window.document.documentElement.dir === 'rtl' : false;
}
